import React, { useEffect } from 'react';
import { focusElement } from 'platform/utilities/ui';
import PasskeyProfilePage from '~/platform/user/authentication/components/PasskeyProfilePage';
import PasskeyAlertProvider from '~/platform/user/authentication/components/PasskeyAlertSlot';
import Headline from '../ProfileSectionHeadline';

export default function Passkeys() {
  useEffect(() => {
    document.title = 'Passkeys | Veterans Affairs';
    focusElement('[data-focus-target]');
  }, []);

  return (
    <>
      <Headline>Passkeys</Headline>
      <p>
        Create and manage passkeys to sign in faster with your fingerprint,
        face, or device lock.
      </p>
      <PasskeyAlertProvider>
        <PasskeyProfilePage />
      </PasskeyAlertProvider>
    </>
  );
}
